import { useCallback, useEffect, useMemo, useState } from 'react';
import { ConfigOption } from '../types';
export function useDeductionLineConfig({ query, isSaving, enabled, canPersist, persist, }) {
    const { data: configs, isLoading, isFetching, isError, refetch } = query;
    const config = useMemo(() => configs?.find(contractConfig => contractConfig.config === ConfigOption.DEDUCTION_LINE), [configs]);
    const [isEnabled, setIsEnabled] = useState(true);
    const [hasSaveError, setHasSaveError] = useState(false);
    useEffect(() => {
        setIsEnabled(config?.isEnable ?? true);
    }, [config]);
    useEffect(() => {
        if (!enabled) {
            setHasSaveError(false);
        }
    }, [enabled]);
    const setEnabled = useCallback(async (nextIsEnabled) => {
        if (!canPersist || !config) {
            return;
        }
        setHasSaveError(false);
        try {
            await persist(config, nextIsEnabled);
            setIsEnabled(nextIsEnabled);
        }
        catch {
            setHasSaveError(true);
        }
    }, [canPersist, config, persist]);
    const clearSaveError = useCallback(() => {
        setHasSaveError(false);
    }, []);
    return {
        config,
        isEnabled,
        isLoading: isLoading || isFetching,
        isSaving,
        hasLoadError: isError,
        hasSaveError,
        setEnabled,
        clearSaveError,
        refetch,
    };
}
